import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { LoaderService } from '@core/services/loader.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-loader',
  imports: [CommonModule, TranslatePipe],
  template: `
    <div class="backdrop" *ngIf="isLoading | async">
      <div class="spinner-border text-primary m-2" role="status">
        <span class="visually-hidden">{{ 'Loading' | translate }}</span>
      </div>
    </div>
  `,
  styles: `
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1060; /* Higher than Bootstrap modals */
}

  `,
})
export class LoaderComponent {
  private loaderService = inject(LoaderService);
  isLoading = this.loaderService.isLoading$;
}
